import { stringify } from 'query-string';

import { resolveStore, resolveProfile } from '../redux-angular-interface';

import { addedToCart } from '../../../product/js/actions/productActions';

import { debug } from '../../../core/js/utils/logger';
import { launchAsyncQuickshop } from '@product/js/utils/asyncLaunchers';
import { getFlatNavigationSync } from '@core/js/utils/navigationUtils';

module.exports = /* @ngInject */
(
    _,
    $q
) => {
    return {
        /**
         * Interface between Angular and Redux.
         * Will resolve a $q promise with the
         * current Redux state once the A15
         * store has been initialized. Use of
         * this method is preferred over getStore,
         * as it ensures that the app has been
         * initialized, preventing race conditions,
         * and enforces immutability.
         * @return {Object} $q promise resolved with the current Redux state
         */
        getState() {
            return this.getStore()
                .then((store) => {
                    return store.getState();
                });
        },

        /**
         * Interface between Angular and Redux.
         * Will resolve a $q promise with the
         * Redux getState function once the A15
         * app has been created.
         * @return {Object} $q promise resolved with the current Redux state
         */
        getStore() {
            const deferred = $q.defer();

            resolveStore(deferred);

            return deferred.promise;
        },

        getProfile() {
            const deferred = $q.defer();

            resolveProfile(deferred);

            return deferred.promise;
        },

        /**
         * Interface between Angular and Redux
         * for launching Quickshop.
         * @param  {Object} data Quickshop item data
         * @param  {Object} options Quickshop options
         * @param  {Object} e    HTML Event
         * @return {Object} $q promise with the Redux store
         */
        launchQuickshop(data, options, e) {
            return this.getStore()
                .then((store) => {
                    debug('Launching Quickshop from Angular');

                    const item = _.cloneDeep(data.item);
                    const queryParams = {
                        category: options.source,
                        color: data.sku.colorId,
                        quantity: item.quantity,
                        size: data.size.displayName,
                        type: data.sku.sizeTypeCode
                    };
                    const qs = stringify(queryParams);

                    item.catalogInfo.product = _.merge(item.catalogInfo.product, {
                        queryParams: qs,
                        productSlug: item.catalogInfo.productSlug
                    });

                    const records = [item];

                    launchAsyncQuickshop(store, options, e, records, 0, 'catalogInfo');

                    return store;
                });
        },

        /**
         * Show the add-to-cart confirm messaging when an item
         * has been added to the cart.
         * @param  {Object} e                jQuery Event Object
         * @param  {String} component        Component name
         * @param  {Object} confirmViewModel View model
         * @return {Object}                  $q promise that is resolved once the messaging is dispatched.
         */
        showConfirmMessage(e, component, confirmViewModel) {
            return this.getStore()
                .then((store) => {
                    const deferred = $q.defer();

                    store.dispatch(addedToCart(
                        {
                            showConfirm: true,
                            confirmViewModel: confirmViewModel,
                            isConfirmTimerActive: true,
                            quantityRequested: confirmViewModel.quantity
                        },
                        false,
                        component
                    ));

                    return deferred.promise;
                });
        },

        getFlatNavigation() {
            return this.getStore()
                .then((store) => {
                    return getFlatNavigationSync(store);
                });
        }
    };
};
